export const PaymentsIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.99998 9H35V14H4.99998V9Z" fill="black" />
      <path d="M4.96545 17.1484H35.0346V30H4.96545V17.1484Z" fill="black" />
    </svg>
  )
}
